import { StaticImage } from "gatsby-plugin-image"
import React, { useEffect, useRef } from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  min-height: 40vh;
  z-index: 0;
  color: #fff;
  background-color: #fac348;
  color: #341644;
  margin-top: 150px;

  .top {
    position: absolute;
    top: -150px;
    left: 0;
    width: 100%;
    height: 150px;
    background-image: url("/images/parents-v2/yellow-section-top-wave-desktop.svg");
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .quote {
    transform: rotate(-4deg);
    max-width: 600px;
    padding-bottom: 150px;

    .quote--text {
      font-size: 1.3em;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .quote--author {
      > :first-child {
        font-weight: bold;
      }
    }
  }

  .bottom {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 150px;
    background-image: url("/images/parents-v2/darkpurple-section-top-wave-desktop.svg");
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;
  }

  .josh-blob {
    /* position: absolute; */
    height: 600px;
    width: 600px;
    bottom: 0;
    min-width: 600px;
    transform: translate(20%, 0%);
    > * {
      position: absolute;
      will-change: transform;
    }
    > :nth-child(1) {
      // Blob
      height: 90%;
      width: 90%;
    }

    > :nth-child(2) {
      // Josh
      height: 100%;
      bottom: -5%;
      right: 0%;
    }

    > :nth-child(3) {
      // Spark
      height: 18%;
      right: 22%;
      bottom: 18%;
    }
  }

  @media screen and (max-width: 1220px) {
    .quote {
      max-width: 340px;
    }
  }

  @media screen and (max-width: 1179px) {
    .content {
      flex-direction: column;
      padding: 0 10px;
    }
    padding: 0 40px;

    .quote {
      max-width: 540px;
      transform: rotate(0deg);
      max-width: none;
      font-size: 1.2em;
      line-height: 1.2;
      padding-bottom: 0;
      margin: 0 auto;
      text-align: center;

      .quote--text {
        margin-bottom: 40px;
      }
      .quote--author {
        .quote--author-name {
          font-size: 1.2em;
        }
      }
    }

    .josh-blob {
      margin-top: 50px;
      width: 350px;
      height: 350px;
      min-width: 350px;
      bottom: 0px;
      transform: translate(10%, -5%);
    }
  }
`

export const ParentsV2_JoshQuote = (props: {
  quote: string
  author: {
    name: string
    description: string
  }
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const blobRef = useRef<HTMLImageElement>(null)
  const joshRef = useRef<HTMLDivElement>(null)
  const sparkRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const onScroll = () => {
      if (!wrapperRef.current) return
      const rect = wrapperRef.current.getBoundingClientRect()
      const offset = rect.top + rect.height / 2 - window.innerHeight / 2
      if (blobRef.current)
        blobRef.current.style.transform = `translateY(${offset * 0.1}px)`
      if (joshRef.current)
        joshRef.current.style.transform = `translateY(calc(-20px + ${offset * 0.1
          }px))`
      if (sparkRef.current)
        sparkRef.current.style.transform = `translateY(${offset * 0.4}px)`
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <Wrapper ref={wrapperRef}>
      <div className="top" />
      <div className="content">
        <div className="quote">
          <div className="quote--text">
            "{props.quote}"
          </div>
          <div className="quote--author">
            <div className="quote--author-name">{props.author.name}</div>
            <div className="quote--author-description">{props.author.description}</div>
          </div>
        </div>

        <div className="josh-blob">
          <img ref={blobRef} src="/images/parents-v2/purple-blog-josh-bg.svg" />
          <div ref={joshRef}>
            <StaticImage placeholder="blurred" src="../../../images/parents-v2/josh-with-book-isolated.png" alt="Josh Davidson" layout="constrained" width={580} quality={80} />
          </div>
          <img
            ref={sparkRef}
            src="/images/parents-v2/white-splat-doodle-icon.svg"
          />
        </div>
      </div>

      <div className="bottom" />
    </Wrapper>
  )
}
